import { render, staticRenderFns } from "./dataTableTest.vue?vue&type=template&id=298669b3"
import script from "./dataTableTest.vue?vue&type=script&lang=js"
export * from "./dataTableTest.vue?vue&type=script&lang=js"
import style0 from "./dataTableTest.vue?vue&type=style&index=0&id=298669b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports